import { render, staticRenderFns } from "./JobsDetails.vue?vue&type=template&id=d4499334&scoped=true&"
import script from "./JobsDetails.vue?vue&type=script&lang=js&"
export * from "./JobsDetails.vue?vue&type=script&lang=js&"
import style0 from "./JobsDetails.vue?vue&type=style&index=0&id=d4499334&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4499334",
  null
  
)

export default component.exports